export abstract class AFilter {

}


export class SingleEntityTextFilter extends AFilter {
    public searchString: string ;

    constructor(searchString: string) {
        super();
        this.searchString = searchString;
    }
}

export class MultiEntitiesTextFilter extends SingleEntityTextFilter {
    public searchableEntities: string[] = new Array();
}
